"use client";

import React, { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowDownRight, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AboutHero() {
  const shouldReduceMotion = useReducedMotion();
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: isMounted && shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut"
      }
    }
  };
  return <section id="abouthero" data-nav="dark" className="relative min-h-[580px] md:min-h-[680px] lg:min-h-[740px] flex items-end justify-start overflow-hidden bg-background text-primary-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/hero_about.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/hero_about.png-wvc-sizes" alt="Reunión y adoración comunitaria de las Asambleas de Dios" loading="lazy" decoding="async" className="h-full w-full object-cover object-center scale-105 !bg-[rgba(0,0,0,0.52)]" src="https://current-thrush.10web.cloud/wp-content/uploads/2026/08/01.jpg" />
        
        {}
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent" />
        <div className="absolute inset-0 from-background/80 via-background/40 to-transparent !opacity-[1] !text-[rgba(255,255,255,1)] !bg-[rgba(0,0,0,0.44)]" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-16 md:pb-24 pt-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="lg:col-span-8 space-y-6">
            <div className="inline-flex items-center gap-2 rounded-lg bg-primary/20 backdrop-blur-md px-3.5 py-1.5 border border-primary-foreground/20 text-xs md:text-sm font-medium tracking-wide uppercase">
              <Compass className="size-4" />
              <span>Sobre Nosotros - Asambleas de Dios</span>
            </div>

            {}
            <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight uppercase leading-tight md:leading-[1.1] text-primary-foreground">SOBRE ASAMBLEAS DE DIOS</h1>

            <p className="max-w-2xl text-lg sm:text-xl md:text-2xl font-normal leading-relaxed text-primary-foreground/90">Las Asambleas de Dios son una confraternidad mundial de iglesias cuya misión es evangelizar a los perdidos, adorar a Dios, discipular a los creyentes y mostrar compasión hacia los demás.</p>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="lg:col-span-4 flex lg:justify-end items-end">
            <Link to="#about-history" aria-label="Descubre más acerca de nuestra historia">
              <Button size="lg" variant="secondary" className="group rounded-lg size-16 md:size-20 p-0 flex items-center justify-center transition-transform hover:scale-105">
                <ArrowDownRight className="size-8 md:size-10 transition-transform group-hover:rotate-45" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}